import { resolveEntryUnitIds } from "@autodromo/units";
import { resolveEntryTitle } from "./entryTitle";

/**
 * Retrato da entry do CMS que a página de item representa: a coleção a que pertence, o id e
 * o título de exibição.
 */
export type PageEntry = {
  contentTypeId?: string | null;
  id?: string | null;
  title?: string;
  unitIds?: string[];
};

/**
 * O `contentTypeId` vem do `{slug}.item.json` (gravado na publicação) e o resto da entry do
 * CMS — origens diferentes, então precisa ser resolvido pelo renderer e passado pronto: as
 * árvores de header e de página não enxergam as duas coisas ao mesmo tempo.
 *
 *
 * Genérico de propósito — é contexto de página, não de um bloco específico.
 */
export const resolvePageEntry = ({
  pageData,
  dynamicPageContent,
}: {
  pageData?: { moduleContentTypeId?: string | null } | null;
  dynamicPageContent?:
    | { _metadata?: { id?: string | null; title?: unknown } | null; slug?: string | null }
    | null;
}): PageEntry => ({
  contentTypeId: pageData?.moduleContentTypeId ?? null,
  id: dynamicPageContent?._metadata?.id ?? null,
  title: resolveEntryTitle({ entry: dynamicPageContent }),
  unitIds: resolveEntryUnitIds({ entry: dynamicPageContent }),
});
